<div class="hero-section">
    <app-menu-bar></app-menu-bar>
    <div class="overlay-content">
        <span class="title">Equipment</span>
        <span class="subtitle">Every FYES device, with its technical specifications.</span>
    </div>
</div>

<section class="equipment-section">
    <div class="toolbar">
        <span class="count">
            @if (!loading && !failed) {
                {{ filtered.length }} {{ filtered.length === 1 ? 'product' : 'products' }}
            }
        </span>
        <input class="search" type="text" placeholder="Search by code or name" autocomplete="off"
            [(ngModel)]="search" />
    </div>

    @if (loading) {
        <div class="state">
            <span class="spinner" role="status" aria-label="Loading equipment"></span>
        </div>
    } @else if (failed) {
        <div class="state">
            <p class="state-text">We couldn't load the catalogue just now.</p>
            <button type="button" class="retry-btn" (click)="load()">Try again</button>
        </div>
    } @else if (equipment.length === 0) {
        <p class="state-text">No equipment to show yet.</p>
    } @else if (filtered.length === 0) {
        <p class="state-text">Nothing matches “{{ search }}”.</p>
    } @else {
        <div class="equipment-grid">
            @for (item of filtered; track item.id) {
                <article class="equipment-card" tabindex="0" role="link"
                    (click)="open(item)" (keydown.enter)="open(item)" (keydown.space)="open(item)">
                    <div class="thumb">
                        @if (imagePending(item)) {
                            <!-- Holds the tile while the signed S3 URL is still in flight. -->
                            <span class="thumb-skeleton" aria-hidden="true"></span>
                        }
                        @if (item.image && !imageBroken(item)) {
                            <img [src]="item.image" [alt]="item.code" loading="lazy" decoding="async"
                                [class.is-loaded]="!imagePending(item)"
                                (load)="onImageLoad(item)" (error)="onImageError(item)" />
                        }
                    </div>
                    <div class="card-text">
                        <span class="code">{{ item.code }}</span>
                        @if (item.name) {
                            <span class="name">{{ item.name }}</span>
                        }
                    </div>
                </article>
            }
        </div>
    }
</section>

<app-footer></app-footer>
